<template>
  <v-container fluid class="fill-height py-0">
    <v-row justify="center" align="center" class="skewed-bg">
      <v-col cols="12" sm="12" md="11" lg="10" style="z-index:1" class="pa-0">
        <v-row>
          <v-col cols="12" align="right" class="pa-0">
            <v-btn
              :class="mobile ? ' my-2' : 'mr-4'"
              tile
              color="#0e62ed"
              dark
              :block="mobile"
              :to="{ name: 'Create Word', params: { mode: 'create' } }"
              v-if="permission_create_edit_word"
            >
              <v-icon left>mdi-plus-circle</v-icon>
              <h4 class="mt-1">{{ btn_transcription_title }}</h4>
            </v-btn>
            <!-- <v-btn
              :class="mobile ? 'my-2' : 'ma-2'"
              tile
              color="#0e62ed"
              outlined
              :block="mobile"
            >
              <v-icon left>mdi-note-text</v-icon>
              <h4 class="mt-1">{{ btn_history_title }}</h4>
              <v-icon right>mdi-chevron-down </v-icon>
            </v-btn>-->
            <v-menu :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  :class="mobile ? 'my-2' : 'my-2'"
                  tile
                  color="#0e62ed"
                  outlined
                  :block="mobile"
                  v-on="on"
                  v-if="
                    permission_satisfaction ||
                      permission_history ||
                      permission_unknown_word
                  "
                >
                  <v-icon left>mdi-note-text</v-icon>
                  <h4 class="mt-1">{{ btn_history_title }}</h4>
                  <v-icon right>mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-list>
                  <v-list-item
                    :to="
                      permission_history
                        ? { name: 'History', params: { mode: 'history' } }
                        : permission_unknown_word
                        ? { name: 'History', params: { mode: 'unknown_word' } }
                        : ''
                    "
                    v-if="permission_history || permission_unknown_word"
                  >
                    <v-list-item-action class="mr-2">
                      <v-icon>mdi-note-text</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>ประวัติการค้นหาคำทับศัพท์</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click :to="'/satisfaction'" v-if="permission_satisfaction">
                    <v-list-item-action class="mr-2">
                      <v-icon>mdi-note-text</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>แบบประเมินความพึงพอใจ</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>

        <v-row class="py-5" justify="center" align="center">
          <v-col cols="12" class="pa-0">
            <v-row class="py-5" justify="center" align="center">
              <v-col
                cols="12"
                sm="4"
                md="4"
                :class="!mobile ? 'py-0' : null"
                v-for="(item, index) in summary"
                :key="item.title"
              >
                <v-card
                  @click="changeMode(item.mode, item.title)"
                  style="background-color: white"
                  :style="{
                    border: filter_mode == item.mode ? '3px solid #0c57d2' : '',
                  }"
                >
                  <v-container class="fill-height">
                    <v-row justify="center" align="center">
                      <v-col cols="12" class="py-0" justify="center" align="center">
                        <div class="text_title_2">คำทับศัพท์</div>
                        <div class="text_title_2">{{ item.title }}</div>

                        <!-- <v-col cols="6" align="center" class="pa-0">
                            <v-img
                              :style="index == 0 ? 'margin-right:10px' : ''"
                              :width="index == 0 ? '19%' : '15%'"
                              :src="item.icon"
                            ></v-img>
                        </v-col>-->
                        <!-- <v-col cols="12" align="center" class="py-0"> -->
                        <v-row justify="center" align="center">
                          <v-col cols="12" justify="center" align="center" class="py-0">
                            <v-avatar
                              :style="
                                index == 0
                                  ? 'margin-top:-10px;margin-right:8px'
                                  : 'margin-top:-10px'
                              "
                              tile
                              :size="index == 0 ? '36' : '35'"
                            >
                              <v-img class="ma-0 pa-0" width="100%" contain :src="item.icon"></v-img>
                            </v-avatar>
                            <span class="text_title_2">{{ formatNumber(item.text) }}</span>
                          </v-col>
                        </v-row>

                        <!-- </v-col> -->
                      </v-col>
                    </v-row>
                  </v-container>
                  <!-- <v-container class="fill-height " fluid>
                    <v-row justify="center" align="center">
                      <v-col cols="12" class="py-0">
                        <v-col
                          cols="12"
                          class="py-0"
                          justify="center"
                          align="center"
                        >
                          <div class="text_title_2">คำทับศัพท์</div>
                          <div class="text_title_2">{{ item.title }}</div>

                          <v-row>
                            <v-col class="py-0">
                              <v-row justify="center" align="center">
                                <v-col cols="6" align="right" class="pa-0">
                                  <v-img
                                    :style="
                                      index == 0 ? 'margin-right:10px' : ''
                                    "
                                    :width="index == 0 ? '50px' : '40px'"
                                    :src="item.icon"
                                  ></v-img>
                                </v-col>
                                <v-col cols="6" align="left" class="py-0">
                                  <span class="text_title_2">
                                    {{ formatNumber(item.text) }}
                                  </span>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-container>-->
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" md="5" class="py-0">
            <v-row>
              <v-col cols="12" sm="6" md="6" class="pa-0">
                <v-menu
                  ref="menu_start_date"
                  v-model="menu_start_date"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="start_dateFormatted"
                      placeholder="วันที่เริ่มต้น"
                      single-line
                      dense
                      solo
                      append-icon="event"
                      v-on="on"
                      clearable
                      @click:clear="start_date = ''"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="start_date"
                    no-title
                    @input="menu_start_date = false"
                    locale="th"
                    :max="end_date"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6" :class="mobile ? 'pa-0' : 'py-0'">
                <v-menu
                  ref="menu_end_date"
                  v-model="menu_end_date"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="end_dateFormatted"
                      placeholder="วันที่สิ้นสุด"
                      single-line
                      dense
                      solo
                      append-icon="event"
                      v-on="on"
                      clearable
                      @click:clear="end_date = ''"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="end_date"
                    no-title
                    locale="th"
                    @input="menu_end_date = false"
                    :min="start_date"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="7" class="pa-0">
            <v-row>
              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-text-field
                  v-model="search"
                  solo
                  dense
                  single-line
                  placeholder="ค้นหา"
                  append-icon="mdi-magnify"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" align="right" class="py-0 px-0">
            <v-col
              cols="12"
              :md="filter_mode == 'pendingWord' ? '6' : '4'"
              :sm="filter_mode == 'pendingWord' ? '8' : '6'"
              class="pa-0"
            >
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-row>
                    <v-col
                      v-if="filter_mode == 'pendingWord'"
                      cols="12"
                      :sm="filter_mode == 'pendingWord' ? '4' : '6'"
                      :md="filter_mode == 'pendingWord' ? '4' : '6'"
                      class="pt-0"
                    >
                      <v-btn
                        :block="mobile"
                        color="primary"
                        :disabled="selected.length == 0"
                        outlined
                        height="40"
                        class="mb-2"
                        @click="publicWord(selected)"
                      >
                        <v-icon left>mdi-bullhorn</v-icon>
                        <span class="text_body_6 mt-1">ประกาศใช้</span>
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="filter_mode == 'pendingWord' ? '4' : '6'"
                      :md="filter_mode == 'pendingWord' ? '4' : '6'"
                      class="py-0"
                    >
                      <v-autocomplete
                        v-model="filter_language"
                        :items="language_list"
                        item-text="languageName"
                        item-value="languageId"
                        outlined
                        single-line
                        dense
                        placeholder="ภาษาทั้งหมด"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="filter_mode == 'pendingWord' ? '4' : '6'"
                      :md="filter_mode == 'pendingWord' ? '4' : '6'"
                      class="py-0"
                    >
                      <v-autocomplete
                        v-model="filter_category"
                        :items="category_list"
                        item-text="categoryName"
                        item-value="categoryId"
                        outlined
                        single-line
                        dense
                        placeholder="หมวดหมู่คำทั้งหมด"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-col>
        </v-row>
        <v-row v-if="table_detail.length == 0">
          <v-col cols="12" align="center">
            <v-img width="300px" src="@/assets/no-result.png"></v-img>
          </v-col>
        </v-row>
        <v-row v-if="table_detail.length > 0">
          <v-col cols="12" class="pa-0">
            <v-card flat>
              <p class="text_title_3">
                คำทับศัพท์{{ table_title }}
                {{ formatNumber(count_word) }} รายการ
              </p>
            </v-card>

            <v-data-table
              v-model="selected"
              item-key="subLanguageId"
              id="table-text"
              :headers="headers"
              :items="table_detail"
              class="elevation-1"
              :loading="loading"
              hide-default-footer
              :items-per-page="item_per_page"
              :show-select="filter_mode == 'pendingWord'"
            >
              <template v-slot:item.createdAt="{ item }">
                <div class="text-left">
                  {{
                  item.createdAt.length > dataTableLength
                  ? item.createdAt.substring(0, dataTableLength) + "..."
                  : item.createdAt
                  }}
                </div>
              </template>
              <template v-slot:item.alphabet="{ item }">
                <div class="text-left">
                  {{
                  item.alphabet.length > dataTableLength
                  ? item.alphabet.substring(0, dataTableLength) + "..."
                  : item.alphabet
                  }}
                </div>
              </template>
              <template v-slot:item.transcription="{ item }">
                <div class="text-left">
                  {{
                  item.transcription.length > dataTableLength
                  ? item.transcription.substring(0, dataTableLength) + "..."
                  : item.transcription
                  }}
                </div>
              </template>
              <template v-slot:item.languageName="{ item }">
                <div class="text-left">
                  {{
                  item.languageName.length > dataTableLength
                  ? item.languageName.substring(0, dataTableLength) + "..."
                  : item.languageName
                  }}
                </div>
              </template>
              <template v-slot:item.categoryName="{ item }">
                <div class="text-left">
                  {{
                  item.categoryName.length > dataTableLength
                  ? item.categoryName.substring(0, dataTableLength) + "..."
                  : item.categoryName
                  }}
                </div>
              </template>
              <template v-slot:item.createBy="{ item }">
                <div class="text-left">
                  {{
                  item.createBy.length > dataTableLength
                  ? item.createBy.substring(0, dataTableLength) + "..."
                  : item.createBy
                  }}
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-row justify="center" align="center" no-gutters v-if="!mobile">
                  <v-col
                    :lg="filter_mode != 'pendingWord'?'4':'6'"
                    :md="filter_mode != 'pendingWord'?'4':'6'"
                    sm="12"
                    cols="12"
                    :align="tablet || ipad_pro ? 'left' : 'left'"
                    class="pa-0"
                  >
                    <v-btn color="#333333" :text="!mobile" :icon="mobile" @click="viewWord(item)">
                      <v-icon :left="!mobile">mdi-note-text</v-icon>
                      <span class="text_body_7">ดู</span>
                    </v-btn>
                  </v-col>
                  <v-col
                    :lg="filter_mode != 'pendingWord'?'4':'6'"
                    :md="filter_mode != 'pendingWord'?'4':'6'"
                    sm="12"
                    cols="12"
                    :align="tablet || ipad_pro ? 'left' : 'left'"
                    class="pa-0"
                  >
                    <v-btn
                      color="#333333"
                      :text="!mobile"
                      :icon="mobile"
                      @click="editWord(item)"
                      :disabled="!permission_create_edit_word"
                    >
                      <v-icon :left="!mobile">mdi-pencil-box-outline</v-icon>
                      <span class="text_body_7">แก้ไข</span>
                    </v-btn>
                  </v-col>
                  <v-col
                    :lg="filter_mode != 'pendingWord'?'4':'6'"
                    :md="filter_mode != 'pendingWord'?'4':'6'"
                    sm="12"
                    cols="12"
                    :align="tablet || ipad_pro ? 'left' : 'left'"
                    v-if="filter_mode == 'pendingWord'"
                    class="pa-0"
                  >
                    <v-btn
                      v-if="item.subLanguageStatus == 'pending'"
                      color="#333333"
                      :text="!mobile"
                      :icon="mobile"
                      @click="publicWord(item)"
                      :disabled="
                        !permission_create_edit_word || selected.length > 0
                      "
                    >
                      <v-icon :left="!mobile">mdi-bullhorn</v-icon>
                      <span class="text_body_7">ประกาศใช้</span>
                    </v-btn>
                  </v-col>
                  <v-col
                    :lg="filter_mode != 'pendingWord'?'4':'6'"
                    :md="filter_mode != 'pendingWord'?'4':'6'"
                    sm="12"
                    cols="12"
                    :align="tablet || ipad_pro ? 'left' : 'left'"
                    class="pa-0"
                  >
                    <v-btn text @click="delWord(item)" :disabled="!permission_create_edit_word">
                      <v-icon :left="!mobile">mdi-delete</v-icon>
                      <span class="text_body_7">ลบ</span>
                    </v-btn>
                  </v-col>
                  <v-col
                    v-if="filter_mode == 'allWord'"
                    :lg="filter_mode != 'pendingWord'?'4':'6'"
                    :md="filter_mode != 'pendingWord'?'4':'6'"
                    sm="12"
                    cols="12"
                    :align="tablet || ipad_pro ? 'left' : 'left'"
                    class="pa-0"
                  >
                    <v-btn
                      v-if="item.subLanguageStatus == 'pending'"
                      color="#333333"
                      :text="!mobile"
                      :icon="mobile"
                      @click="publicWord(item)"
                      :disabled="
                        !permission_create_edit_word || selected.length > 0
                      "
                    >
                      <v-icon :left="!mobile">mdi-bullhorn</v-icon>
                      <span class="text_body_7">ประกาศใช้</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="mobile">
                  <v-col cols="12" justify="center" align="center">
                    <v-menu>
                      <template v-slot:activator="{ on, attrs }">
                        <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">Dropdown</v-btn> -->
                        <v-btn color="info" outlined v-bind="attrs" v-on="on" small>
                          <v-icon>mdi-dots-horizontal</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item @click="viewWord(item)">
                          <v-list-item-icon class="mr-5">
                            <v-icon>mdi-note-text</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              <span class="text_body_7">ดู</span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="editWord(item)" v-if="permission_create_edit_word">
                          <v-list-item-icon class="mr-5">
                            <v-icon>mdi-pencil-box-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              <span class="text_body_7">แก้ไข</span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                          @click="publicWord(item)"
                          v-if="(permission_create_edit_word && selected.length == 0) && filter_mode == 'pendingWord'"
                        >
                          <v-list-item-icon class="mr-5">
                            <v-icon>mdi-bullhorn</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              <span class="text_body_7">ประกาศใช้</span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="delWord(item)" v-if="permission_create_edit_word">
                          <v-list-item-icon class="mr-5">
                            <v-icon>mdi-delete</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              <span class="text_body_7">ลบ</span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <div class="text-center">
              <v-pagination :total-visible="20" v-model="page" :length="total_page"></v-pagination>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      header_token: {
        headers: {
          token: this.$session.get("token_roy"),
        },
      },
      // perission variable
      permission_create_edit_word: false,
      permission_history: false,
      permission_satisfaction: false,
      permission_unknown_word: false,
      summary: [
        {
          mode: "allWord",
          title: "ในฐานข้อมูลทั้งหมด",
          text: 0,
          icon: require("../../assets/icon/book.png"),
        },
        {
          mode: "activeWord",
          title: "ที่เผยแพร่แล้ว",
          text: 0,
          icon: require("../../assets/icon/add.png"),
        },
        {
          mode: "pendingWord",
          title: "ที่รอการเผยแพร่",
          text: 0,
          icon: require("../../assets/icon/edit.png"),
        },
      ],
      btn_transcription_title: "สร้างคำทับศัพท์",
      btn_history_title: "ประวัติการเข้าใช้งาน",

      table_detail: [],
      menu: false,
      start_date: "",
      end_date: "",
      start_dateFormatted: "",
      end_dateFormatted: "",
      menu_start_date: false,
      menu_end_date: false,
      category_list: [],
      language_list: [],
      item_per_page: 20,
      filter_language: 0,
      filter_category: 0,
      search: "",
      search_setTimeout: null,
      search_const_delay: 500,
      filter_mode: "allWord",
      page: 1,
      total_page: 0,
      count_word: 0,
      params: "",
      loading: false,
      table_title: "คำทับศัพท์ทั้งหมด",
      selected: [],
      count: 0,
      id_list: [],
      error_public: [],
    };
  },
  computed: {
    headers_tablet() {
      return;
    },
  },
  created() {
    const module_name = "permission_backOffice";
    const func_name = "dashboard";
    const redirect = process.env.VUE_APP_HOME;
    if (this.$session.get(module_name)) {
      if (this.$session.get(module_name).includes(func_name)) {
        // initial
        this.initialMethod();
        // set detail
        this.permission_create_edit_word = this.$session
          .get(module_name)
          .includes("create_edit_word");
        this.permission_satisfaction = this.$session
          .get(module_name)
          .includes("satisfaction");
        this.permission_history = this.$session
          .get(module_name)
          .includes("history");
        this.permission_unknown_word = this.$session
          .get(module_name)
          .includes("unknown_word");
      } else {
        this.$router.push(redirect);
      }
    } else {
      this.$router.push(redirect);
    }
  },
  computed: {
    headers() {
      if (this.tablet) {
        return [
          {
            text: "วันที่สร้าง",
            sortable: false,
            value: "createdAt",
            // align: "center",
            width: "20%",
            // class: "pa-0 ma-0",
          },
          {
            text: "อักษรพิเศษ",
            value: "alphabet",
            sortable: false,
            width: "20%",
            class: "pa-0 ma-0",
            // align: "center",
          },
          {
            text: "คำทับศัพท์",
            value: "transcription",
            sortable: false,
            width: "15%",
            class: "pa-0 ma-0",
            // align: "center",
          },
          {
            text: "ภาษา",
            value: "languageName",
            sortable: false,
            width: "10%",
            class: "pa-0 ma-0",
            // align: "center",
          },
          {
            text: "หมวดหมู่คำ",
            value: "categoryName",
            sortable: false,
            width: "10%",
            class: "pa-0 ma-0",
          },
          {
            text: "ผู้รับผิดชอบ",
            value: "createBy",
            sortable: false,
            width: "10%",
            class: "pa-0 ma-0",
            // align: "center",
          },

          {
            align: "center",
            text: "จัดการ",
            value: "actions",
            sortable: false,
            width: "10%",
            class: "pa-0 ma-0",
          },
        ];
      } else if (this.ipad_pro) {
        return [
          {
            text: "วันที่สร้าง",
            sortable: false,
            value: "createdAt",
            // align: "center",
            width: "10%",
            // class: "pa-0 ma-0",
          },
          {
            text: "อักษรพิเศษ",
            value: "alphabet",
            sortable: false,
            width: "15%",
            // class: "pa-0 ma-0",
            // align: "center",
          },
          {
            text: "คำทับศัพท์",
            value: "transcription",
            sortable: false,
            width: "15%",
            // class: "pa-0 ma-0",
            // align: "center",
          },
          {
            text: "ภาษา",
            value: "languageName",
            sortable: false,
            width: "10%",
            // class: "pa-0 ma-0",
            // align: "center",
          },
          {
            text: "หมวดหมู่คำ",
            value: "categoryName",
            sortable: false,
            width: "10%",
            class: "pa-0 ma-0",
          },
          {
            text: "ผู้รับผิดชอบ",
            value: "createBy",
            sortable: false,
            width: "10%",
            // class: "pa-0 ma-0",
            // align: "center",
          },

          {
            align: "center",
            text: "จัดการ",
            value: "actions",
            sortable: false,
            width: "25%",
            // class: "pa-0 ma-0",
          },
        ];
      } else {
        return [
          {
            text: "วันที่สร้าง",
            sortable: false,
            value: "createdAt",
            // align: "center",
            width: "10%",
            // class: "pa-0 ma-0",
          },
          {
            text: "อักษรพิเศษ",
            value: "alphabet",
            sortable: false,
            width: "15%",
            // class: "pa-0 ma-0",
            // align: "center",
          },
          {
            text: "คำทับศัพท์",
            value: "transcription",
            sortable: false,
            width: "15%",
            // class: "pa-0 ma-0",
            // align: "center",
          },
          {
            text: "ภาษา",
            value: "languageName",
            sortable: false,
            width: "10%",
            // class: "pa-0 ma-0",
            // align: "center",
          },
          {
            text: "หมวดหมู่คำ",
            value: "categoryName",
            sortable: false,
            width: "10%",
            class: "pa-0 ma-0",
          },
          {
            text: "ผู้รับผิดชอบ",
            value: "createBy",
            sortable: false,
            width: "10%",
            // class: "pa-0 ma-0",
            // align: "center",
          },

          {
            align: "center",
            text: "จัดการ",
            value: "actions",
            sortable: false,
            width: "20%",
            // class: "pa-0 ma-0",
          },
        ];
      }
    },
    dataTableLength() {
      if (this.mobile) {
        return 15;
      }
      if (this.tablet) {
        return 15;
      }
      if (this.ipad_pro) {
        return 15;
      }
      if (this.desktop) {
        return 15;
      }
    },
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1024
      ) {
        return true;
      } else {
        return false;
      }
    },
    ipad_pro() {
      if (
        this.$vuetify.breakpoint.width >= 1024 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    "$route.params.mode"(value) {
      switch (value) {
        case "all":
          this.filter_mode = "allWord";
          this.table_title = this.summary[0].title;
          break;
        case "created":
          this.filter_mode = "activeWord";
          this.table_title = this.summary[1].title;
          break;
        case "edited":
          this.filter_mode = "pendingWord";
          this.table_title = this.summary[2].title;
          break;
        default:
          this.$router.push({ name: "Dashboard", params: { mode: "all" } });
          break;
      }
      this.page = 1;
      this.searchNumberPage();
    },
    start_date(val) {
      this.start_dateFormatted = this.thaiShortFormatDate(this.start_date);
      this.page = 1;
      this.searchNumberPage();
    },
    end_date(val) {
      this.end_dateFormatted = this.thaiShortFormatDate(this.end_date);
      this.page = 1;
      this.searchNumberPage();
    },
    filter_mode(val) {
      this.page = 1;
      this.searchNumberPage();
    },
    filter_language(val) {
      this.page = 1;
      this.searchNumberPage();
    },
    filter_category(val) {
      this.page = 1;
      this.searchNumberPage();
    },
    search(val) {
      this.page = 1;
      clearTimeout(this.search_setTimeout);
      this.search_setTimeout = setTimeout(() => {
        this.searchNumberPage();
      }, this.search_const_delay);
    },
    page(val) {
      this.searchNumberPage();
    },
    count(val) {
      if (val != 0) {
        if (val == this.id_list.length) {
          this.$swal.fire({
            icon: "success",
            title: "ประกาศใช้คำทับศัพท์สำเร็จ",
            showConfirmButton: false,
            timer: 1000,
          });
          this.getSummary();
          this.searchNumberPage();
        } else {
          var error_message = "";
          if (this.error_public.length > 0) {
            for (let i in this.error_public) {
              error_message = (i == 0 ? "" : " , ") + this.error_public[i];
            }
          }
          this.$swal.fire({
            icon: "error",
            title: "ผิดพลาด กรุณาลองใหม่อีกครั้ง",
            text:
              error_message == "error"
                ? ""
                : "ประกาศใช้ " + error_message + " ผิดพลาด",
          });
          this.getSummary();
          this.searchNumberPage();
        }
      }
    },
  },

  methods: {
    initialMethod() {
      switch (this.$route.params.mode) {
        case "all":
          this.filter_mode = "allWord";
          this.table_title = this.summary[0].title;
          break;
        case "created":
          this.filter_mode = "activeWord";
          this.table_title = this.summary[1].title;
          break;
        case "edited":
          this.filter_mode = "pendingWord";
          this.table_title = this.summary[2].title;
          break;
        default:
          this.$router.push({ name: "Dashboard", params: { mode: "all" } });
          break;
      }
      this.page = 1;
      this.getSummary();
      this.searchNumberPage();
      this.getLanguage();
      this.getCategory();
    },

    changeMode(mode, title) {
      this.filter_mode = mode;
      this.table_title = title;
      this.page = 1;
      this.searchNumberPage();
    },
    getSummary() {
      this.axios
        .get(
          process.env.VUE_APP_API + "api/v1/dashboard/summary",
          this.header_token
        )
        .then((res) => {
          // console.log(res.data);
          var data = res.data;
          this.summary[0].text = data.allWord ? data.allWord : 0;
          this.summary[1].text = data.activeWord ? data.activeWord : 0;
          this.summary[2].text = data.pendingWord ? data.pendingWord : 0;
        });
    },
    searchNumberPage() {
      this.loading = true;
      this.params = "";
      var search = this.search
        ? "?search=" + encodeURIComponent(this.search.trim())
        : "?search=";
      var filter_start_date = this.start_date
        ? "&start=" + this.start_date
        : "&start=";
      var filter_end_date = this.end_date ? "&end=" + this.end_date : "&end=";
      var filter_language = this.filter_language
        ? "&languageId=" + this.filter_language
        : "&languageId=";
      var filter_category = this.filter_category
        ? "&categoryId=" + this.filter_category
        : "&categoryId=";
      var filter_mode = this.filter_mode
        ? "&mode=" + this.filter_mode
        : "&mode=";
      var params =
        search +
        filter_start_date +
        filter_end_date +
        filter_language +
        filter_category +
        filter_mode;
      this.params = params;
      this.axios
        .get(
          process.env.VUE_APP_API +
            "/api/v1/searchlist/numberpage/" +
            this.item_per_page +
            this.params,
          this.header_token
        )
        .then((res) => {
          if (res.data) {
            var data = res.data;
            this.total_page = data.page;
            this.count_word = data.count ? data.count : 0;
            this.searchList();
          }
        });
    },
    searchList() {
      this.axios
        .get(
          process.env.VUE_APP_API +
            "api/v1/searchlist/page/" +
            this.item_per_page +
            "/" +
            this.page +
            this.params,
          this.header_token
        )
        .then((res) => {
          // console.log(res.data);
          var data = res.data;
          var detail = [];
          data.forEach((element) => {
            var date = element.createdAt.split(" ")[0];
            var formatDate = this.thaiShortFormatDate(date);
            element.createdAt = formatDate;
            detail.push({
              categoryId: element.categoryId,
              categoryName: element.categoryName ? element.categoryName : "-",
              createBy: element.createBy ? element.createBy : "-",
              createdAt: formatDate,
              languageId: element.languageId,
              languageName: element.languageName ? element.languageName : "-",
              pointerId: element.pointerId,
              alphabet: element.alphabet ? element.alphabet : "-",
              mean: element.mean ? element.mean : "-",
              subLanguageId: element.subLanguageId,
              transcription: element.transcription,
              userId: element.userId,
              subLanguageStatus: element.subLanguageStatus
                ? element.subLanguageStatus
                : null,
            });
          });
          // console.log(detail);
          this.table_detail = detail;
          this.loading = false;
        });
    },
    publicWord(item) {
      // console.log(item);
      var id = item.subLanguageId;
      this.id_list = [];
      this.error_public = [];
      if (item.length > 0) {
        item.forEach((element) => {
          this.id_list.push({
            id: element.subLanguageId,
            alphabet: element.alphabet,
          });
        });
      } else {
        this.id_list.push({
          id: item.subLanguageId,
          alphabet: item.alphabet,
        });
      }

      var data = {};
      this.count = 0;
      this.$swal
        .fire({
          title: "คุณแน่ใจหรือไม่? ว่าต้องการประกาศใช้คำทับศัพท์นี้",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#0e62ed",
          confirmButtonAlign: "right",
          // cancelButtonColor: "#0e62ed",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        })
        .then((res) => {
          if (res.value == true) {
            for (let i in this.id_list) {
              this.axios
                .put(
                  process.env.VUE_APP_API +
                    "api/v1/admin/sublanguage/approve/" +
                    this.id_list[i].id,
                  data,
                  this.header_token
                )
                .then((res) => {
                  // console.log(res.data);
                  if (res.data == "update success") {
                    this.count += 1;
                  } else {
                    this.count = -1;
                    this.error_public.push(this.id_list[i].alphabet);
                  }
                })
                .catch((err) => {
                  this.count = -1;
                  this.error_public.push("error");
                });
            }
          }
        });
    },
    getCategory() {
      this.axios
        .get(
          process.env.VUE_APP_API + "api/v1/masterdata/category",
          this.header_token
        )
        .then((res) => {
          this.category_list = res.data;
        });
    },
    getLanguage() {
      this.axios
        .get(
          process.env.VUE_APP_API + "api/v1/masterdata/language",
          this.header_token
        )
        .then((res) => {
          this.language_list = res.data;
        });
    },
    viewWord(item) {
      var pointerId = item.pointerId;
      this.$store.state.moduleCreateEditWord.createMode = "read";
      this.$store.commit("getWordByPointerIdViewMode", pointerId);
    },
    editWord(item) {
      // console.log(item);
      var pointerId = item.pointerId;
      this.$store.commit("getWordByPointerId", pointerId);
    },
    delWord(item) {
      var id = item.subLanguageId;
      this.$swal
        .fire({
          title: "แน่ใจหรือไม่ว่าต้องการลบคำทับศัพท์นี้?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#E53935",
          cancelButtonColor: "#9E9E9E",
          confirmButtonText: "Delete",
          cancelButtonText: "Cancel",
        })
        .then((res) => {
          if (res.value == true) {
            this.axios
              .delete(
                process.env.VUE_APP_API + "api/v1/admin/sublanguage/" + id,
                this.header_token
              )
              .then((res) => {
                if (res.data == "delete success") {
                  this.$swal.fire({
                    icon: "success",
                    title: "ลบข้อมูลสำเร็จ",
                    showConfirmButton: false,
                    timer: 1000,
                  });
                  this.searchNumberPage();
                  this.getSummary();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "ผิดพลาด",
                    // showConfirmButton: false,
                    // timer: 1000,
                  });
                }
              });
          }
        });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    thaiShortFormatDate(date_str) {
      if (!date_str) {
        return "";
      }
      var [year, month, day] = date_str.split("-");
      year = parseInt(year) + 543 - 2500;
      switch (month) {
        case "01":
          month = "ม.ค.";
          break;
        case "02":
          month = "ก.พ.";
          break;
        case "03":
          month = "มี.ค.";
          break;
        case "04":
          month = "เม.ย.";
          break;
        case "05":
          month = "พ.ค.";
          break;
        case "06":
          month = "มิ.ย.";
          break;
        case "07":
          month = "ก.ค.";
          break;
        case "08":
          month = "ส.ค.";
          break;
        case "09":
          month = "ก.ย.";
          break;
        case "10":
          month = "ต.ค.";
          break;
        case "11":
          month = "พ.ย.";
          break;
        case "12":
          month = "ธ.ค.";
          break;

        default:
          break;
      }
      return day + " " + month + " " + year;
    },
    formatNumber(num) {
      // return new Intl.NumberFormat().format(num);
      return new Intl.NumberFormat().format(num.toString().replace(/,/g, ""));
    },
  },
};
</script>
<style>
.skewed-bg {
  background: #e9f1fe;
  color: #fff;
  padding: 2em;
  position: relative;
  min-height: 300px;
  overflow: hidden;
  z-index: 0;
}
.skewed-bg::after {
  content: "";
  position: absolute;
  top: 200px;
  left: 0;
  right: 0;
  height: 100%;
  background: #fff;
  transform: skew(0deg, 0deg);
  z-index: 0;
}
</style>
